import React, { useState, useEffect } from "react";
import "./THC.css";

const thcData = [
  {
    title: "IT Professionals",
    description: "Explore opportunities in software, data, cloud, AI, and more.",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&auto=format&fit=crop&q=60",
  },
  {
    title: "Non-IT Professionals",
    description:
      "Opportunities across finance, HR, marketing, operations, and beyond.",
    image:
      "https://media.istockphoto.com/id/1308610989/photo/shot-of-a-young-female-call-center-agent-working-in-office-stock-photo.webp?a=1&b=1&s=612x612&w=0&k=20&c=d5IbTyZAhUnYpZeBpkmJBIDK1t-IwyXmSUbFTjuNC6o=",
  },
  {
    title: "Freshers & Students",
    description:
      "Kickstart your career with internships, entry-level jobs, and mentorship.",
    image:
      "https://images.unsplash.com/photo-1556740758-90de374c12ad?w=600&auto=format&fit=crop&q=60",
  },
  {
    title: "Freelancers & Remote Workers",
    description: "Flexible projects and roles to suit your lifestyle.",
    image:
      "https://images.unsplash.com/photo-1556745753-b2904692b3cd?w=600&auto=format&fit=crop&q=60",
  },
  {
    title: "Recruiters",
    description: "Access verified talent pools and streamline your hiring.",
    image:
      "https://images.unsplash.com/photo-1581090698603-a8a626ffdc14?w=600&auto=format&fit=crop&q=60",
  },
  {
    title: "Career Mentorship",
    description:
      "Guidance to make smarter career moves and upskill effectively.",
    image:
      "https://images.unsplash.com/photo-1581092568395-d68050c2ab43?w=600&auto=format&fit=crop&q=60",
  },
];

const THC = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(2.5);

  // Dynamically update visibleCount based on screen width
  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 768) {
        setVisibleCount(1); // mobile
      } else if (window.innerWidth <= 1024) {
        setVisibleCount(2); // tablet
      } else {
        setVisibleCount(3); // desktop
      }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const maxIndex = Math.max(0, Math.floor(thcData.length - visibleCount));

  const nextSlide = () => {
    setStartIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setStartIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <div
      className="thc-wrapper"
      style={{
        backgroundImage: `url('https://img.freepik.com/free-photo/business-people-career-opportunities_23-2150386153.jpg')`,
      }}
    >
      <div className="thc-content">
        <div className="thc-header">
          <h2 className="thc-heading">
            Creating <span>Impact in Careers</span>
          </h2>
          <div className="thc-carousel-controls">
            <button onClick={prevSlide}>&#8592;</button>
            <button onClick={nextSlide}>&#8594;</button>
          </div>
        </div>

        <div
          className="thc-carousel"
          style={{ transform: `translateX(-${startIndex * (100 / visibleCount)}%)` }}
        >
          {thcData.map((item, index) => (
            <div
              className="thc-card"
              key={index}
              style={{ flex: `0 0 ${100 / visibleCount}%` }}
            >
              <img src={item.image} alt={item.title} />
              <div className="thc-overlay">
                <h3 className="thc-title">{item.title}</h3>
                <p className="thc-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default THC;
